import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anonymous
  const [settings, setSettings] = useState(null);

  const refreshSettings = useCallback(async () => {
    try {
      const { data } = await api.get("/public/settings");
      setSettings(data);
    } catch {
      /* ignore */
    }
  }, []);

  const refreshUser = useCallback(async () => {
    if (!localStorage.getItem("cgland_token")) {
      setUser(false);
      return null;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      localStorage.removeItem("cgland_token");
      setUser(false);
      return null;
    }
  }, []);

  useEffect(() => {
    // Returning from Google OAuth: AuthCallback will exchange session_id first.
    if (window.location.hash?.includes("session_id=")) {
      setUser(false);
      refreshSettings();
      return;
    }
    refreshUser();
    refreshSettings();
  }, [refreshUser, refreshSettings]);

  useEffect(() => {
    if (!user) return undefined;
    const beat = () => api.post("/presence/heartbeat").catch(() => {});
    beat();
    const id = setInterval(beat, 30000);
    return () => clearInterval(id);
  }, [user]);

  const applyAuth = (data) => {
    localStorage.setItem("cgland_token", data.token);
    setUser(data.user);
  };

  const logout = () => {
    api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("cgland_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, settings, refreshSettings, refreshUser, applyAuth, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
